import { render } from "./courier_repayment.vue?vue&type=template&id=a67c6812"
import script from "./courier_repayment.vue?vue&type=script&lang=js"
export * from "./courier_repayment.vue?vue&type=script&lang=js"

import "./courier_repayment.vue?vue&type=style&index=0&id=a67c6812&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__